import SiafLiteApiRepository from "../../external/siafLiteApi";

class NfSaidaItensService {
  constructor() {
    this.urlBase = "/faturamento/nf-saida-itens";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  atualizarLista(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase("/lista/revisao-fiscal", body);
  }
}

export default NfSaidaItensService;
